export function getDeviceModel(anotacion: any): string {
    if (!anotacion) return 'S/M';
    try {
        const parsed = typeof anotacion === 'string' ? JSON.parse(anotacion) : anotacion;
        return parsed?.model || 'S/M';
    } catch {
        const match = String(anotacion).match(/model:\s*["']?([^"',}]+)["']?/);
        return match ? match[1].trim() : 'S/M';
    }
}


import store from "@/store";
import { computed } from "vue";
const projectName = computed(() => store.state.projectName);
import { NAME_PROJECT } from "@/constants/labels";

export function extractNumberFromName(name: string, tipo: string): string {
    if (!name) return "";

    const isCollahuasi = projectName.value === NAME_PROJECT.collahuasi;
    const isCananeaGroup = [NAME_PROJECT.cananea, NAME_PROJECT.demo, NAME_PROJECT.nacozari].includes(projectName.value);

    const cleanTipo = tipo.toUpperCase();

    if (isCananeaGroup) {
        if (cleanTipo === "RAJANT" || cleanTipo === "AP MOVIL") return name.split("-")[0] || "";
        if (cleanTipo === "PMPSM" || cleanTipo === "PMP-SM") return name.split("M")[1] || "";
    }

    if (isCollahuasi) {
        if (cleanTipo === "RAJANT" || cleanTipo === "AP MOVIL") return name.split("-")[2] || "";
        if (cleanTipo === "PMPSM" || cleanTipo === "PMP-SM") return name.split("-")[3] || "";
    }

    const match = name.match(/\d+/);
    return match ? match[0] : "";
}